import { render, staticRenderFns } from "./orderNoticeId.vue?vue&type=template&id=19a555f8"
import script from "./orderNoticeId.vue?vue&type=script&lang=js"
export * from "./orderNoticeId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports